import styled from "vue-styled-components";

export const Content = styled.div`
    display: flex;
    margin-top: 20px;

    section {
        margin-bottom: 2rem;

        h3 {
            font-size: 16px;
            margin: 0;
            font-weight: 500;
        }

        h3 + p {
            margin-top: 0.7rem;
        }

        p {
            margin: 0.3rem 0 0;
            font-size: 12px;
            font-weight: 400;
        }
    }

    .table-responsive {
        width: 100%;
        font-size: 16px;
        color: black;

        tr {
            font-weight: 500 !important;
        }

        th {
            font-weight: 500;
            padding-bottom: 1.5rem;
            p {
                font-size:12px;
            }
        }

        td {
            text-align: end;
            padding-bottom: 1.5rem;
        }

        h3 {
            margin-bottom: 0
        }

        p {
            margin-bottom: 0
        }
    }


`;
